import { setValue } from '../../lib/immutable_wrapper'
import {
    SET_RESULT_SEARCH_QUOTE, SET_FILTERED_AND_SORTED_QUOTES, SET_SELECTED_TYPE,
    SET_SELECTED_STATE, SET_START_DATE, SET_END_DATE, SET_ALL_QUOTES,
    SET_DISPLAY_AS_LIST
} from "./quoteConstants";
import { getStates, getTypes } from './quoteActions';
import { ALL_SELECT_OPTION } from '../../constants';

const initialState = {
    resultSearchQuote: "",
}

const quotesInitialState = {
    filteredAndSortedQuotes: [],
    allQuotes: [],
    types: getTypes(),
    states: getStates(),
    selectedState: ALL_SELECT_OPTION,
    selectedType: ALL_SELECT_OPTION,
    startDate: null,
    endDate: null,
    displayAsList: true,
}

export function quote(state = initialState, action) {
    switch (action.type) {
        case SET_RESULT_SEARCH_QUOTE:
            return setValue(state, ['resultSearchQuote'], action.resultSearchQuote);
        default:
            return state;
    }
}

export function quotes(state = quotesInitialState, action) {
    switch (action.type) {
        case SET_FILTERED_AND_SORTED_QUOTES:
            return setValue(state, ['filteredAndSortedQuotes'], action.quotes);
        case SET_ALL_QUOTES:
            return setValue(state, ['allQuotes'], action.allQuotes);
        case SET_SELECTED_TYPE:
            return setValue(state, ['selectedType'], action.selectedType);
        case SET_SELECTED_STATE:
            return setValue(state, ['selectedState'], action.selectedState);
        case SET_START_DATE:
            return setValue(state, ['startDate'], action.startDate);
        case SET_END_DATE:
            return setValue(state, ['endDate'], action.endDate);
        case SET_DISPLAY_AS_LIST:
            return setValue(state, ['displayAsList'], action.displayAsList);
        default:
            return state;
    }
}
